import { MAX_SEARCH_TERM_LENGTH } from "./globals";

export const messages = {
    meta: {
        id: "ID",
        title: "Titel",
        score: "Score",
        fach: "Fach",
        schulart: "Schulform",
        klassenstufe: "Klassenstufe",
        klasse: "Klasse",
        lernjahr: "Lernjahr",
        competences: "Kompetenzen",
        methods: "Methoden",
        keywordList: "Schlagwortliste",
        description: "Beschreibung",
        original: "Original",
        newBadge: "NEU",
        pruefansichtBadge: "ENTWURF",
        pruefansichtTitle: "Entwurf",
        pruefansichtNote:
            "Dieser Beitrag ist noch nicht veröffentlicht und befindet sich in der Prüfansicht.",
    },
    app: {
        title: "RAAbits",
        description: "Online Portal von RAAbits",
        welcomeBack: "Willkommen zurück",
        search: {
            title: "Suche",
            placeholder: "Suche nach Themen",
        },
        signin: {
            entra: {
                loginButtonText: "Anmelden bei Microsoft Entra",
                welcomeMessage: "Angemeldet bei Microsoft Entra als {%s}",
            },
        },
        footer: {
            privacyPolicy: "Datenschutz",
            cancellationPolicy: "Widerrufsbelehrung",
            contactUs: "Kontakt",
            legalNotice: "Impressum",
            generalTermsAndConditions: "AGB",
            faq: "FAQ",
            aboutUs: "Was ist RAAbits Online?",
            ourOffer: "Unser Angebot",
            schoolSubscriptions: "Schulabonnements",
            showLess: "Weniger anzeigen",
            showMore: "Mehr anzeigen",
        },
        error: {
            title: "Entschuldigung, ein Fehler ist aufgetreten...",
            tryAgain: "Erneut versuchen",
        },
    },
    cancel: "Abbrechen",
    error: {
        closeToast: "Meldung schließen",
        browserOutdated: {
            title: "Fehler",
            message:
                "Die von Ihnen verwendete Browserversion wird zur Anzeige des Unterrichtmaterials nicht unterstützt. Bitte verwenden Sie eine neuere Version des Browsers.\n" +
                "Unterstützt werden: \n" +
                "Chrome ≥119, \n" +
                "Edge ≥119, \n" +
                "Safari ≥17.4, \n" +
                "Firefox ≥121",
        },
        loadingImage: {
            title: "Fehler",
            message: "Bild konnte nicht geladen werden",
        },
        loadingPreview: {
            title: "Fehler",
            message: "Vorschau konnte nicht geladen werden",
        },
        notAuthenticated: {
            title: "Nicht angemeldet",
            message:
                "Sie sind nicht angemeldet. Bitte melden Sie sich an und führen die Aktion erneut durch.",
        },
        ratelimit: {
            title: "Zu viele Anfragen",
            message: "Bitte versuchen Sie es später erneut",
        },
        searchFilter: {
            title: "Fehler beim Laden der Filteroptionen",
            message:
                "Die Optionen für die Filter konnten nicht geladen werden. Bitte versuchen Sie es später erneut.",
        },
        unknown: {
            title: "Unerwarteter Fehler",
            message:
                "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
        },
    },
    nav: {
        back: "Zurück",
        collapse: "Navigation einklappen",
        expand: "Navigation ausklappen",
        home: "Startseite",
        hide: "Navigation schließen",
        hideIcon: "Schließen Icon",
        hideSubNav: "Zurück zum Hauptmenü",
        navItems: {
            home: "Home",
            search: "Suche",
            discover: "Entdecken",
            bibliothek: "Bibliothek",
            account: "Mein Konto",
            login: "Anmelden",
            logout: "Abmelden",
        },
        open: "Navigation ausklappen",
        openIcon: "Navigation Icon",
    },
    pagination: {
        first: "Zum Anfang",
        previous: "Zurück",
        next: "Weiter",
        entries: "Ergebnisse anzeigen",
        entriesShown: "Ergebnisse anzeigen",
        last: "Zum Ende",
    },
    search: {
        searchModal: "Suchfilter",
        klassenstufeHeadline: "Klassenstufe",
        schulformHeadline: "Schulform",
        fachHeadline: "Fach",
        cancelFilter: "Abbrechen",
        applyFilter: "Filter anwenden",
        showFilterModal: "Filteroptionen anzeigen",
        showFilters: "Filteroptionen für {%s}",
        filters: "Suchfilter",
        button: "Suchen",
        for: " für ",
        match: "Ergebnis",
        matches: "Ergebnisse",
        reset: "Zurücksetzen",
        searchIcon: "Suche Icon",
        searchSingle: "Suchergebnis",
        searchMultiple: "Suchergebnisse",
        searchResult: "Suchergebnisse für",
        noMatchesHeader: "Keine Ergebnisse",
        noMatches: "Hierzu wurden noch keine Materialien eingeschult.",
        noMatchesHint: "Verwenden Sie einen anderen Suchbegriff oder passen Sie Ihre Filter an.",
        invalidLength: `Es sind maximal ${MAX_SEARCH_TERM_LENGTH} Zeichen erlaubt.`,
        startSearch: "Suche starten",
        toResult: "zum Ergebnis",
        resetAll: "Alle Filter zurücksetzen",
    },
    tag: {
        remove: "Entfernen",
        removeAll: "Alle Filter zurücksetzen",
    },
    unterrichtsmaterial: {
        metaLabel: "Weitere Informationen zum Unterrichtsmaterial",
        klassenstufeSuffix: ". Klasse",
        loading: "Inhalte werden geladen...",
        noContentFound: "Es wurden keine Inhalte gefunden",
        contentFound: "Es wurden {%s} Inhalte gefunden",
        beitrag: {
            noValue: "Keine Angabe",
            duration: "Unterrichtsdauer",
            hours: "Unterrichtsstunden",
            notFound: "Das gesuchte Unterrichtsmaterial mit der Nummer {%s} wurde nicht gefunden.",
            actions: {
                buttonName: "Aktionen",
                pdf: "Download als PDF",
                word: "Download als Word",
                extraMaterial: "Zusatzmaterialien als ZIP",
            },
        },
        dita: {
            title: "Aufgabe {%s}",
            reset: "Antwort zurücksetzen",
            review: "Überprüfen",
            next: "Weiter",
            showSolutions: "Lösungen anzeigen",
            openMaterial: "Material öffnen",
            leaveFullscreen: "Vollbilddarstellung beenden",
            enterFullscreen: "Vollbilddarstellung öffnen",
            correctAnswer: "richtige Antwort",
            incorrectAnswer: "falsche Antwort",
            expectedAnswer: "erwartete Antwort",
        },
        pdf: {
            of: "von",
            first: "Zur ersten Seite",
            previous: "Zur vorherigen Seite",
            next: "Zur nächsten Seite",
            last: "Zur letzten Seite",
            show: "Material öffnen",
            dialogTitle: "Vollbilddarstellung",
            dialogDescription: "Vollbildansicht des Dokuments",
            requestFullscreen: "Vollbilddarstellung öffnen",
            exitFullscreen: "Vollbilddarstellung beenden",
        },
    },
    fach: {
        notFound: "Das gesuchte Fach {%s} wurde nicht gefunden.",
    },
    bibliothek: {
        title: "Bibliothek",
        contentTitle: "Titel",
        tree: {
            entryType: {
                folder: "Ordner",
                interactive: "Interaktivbeitrag",
                media: "Multimediabeitrag",
                standard: "Standardbeitrag",
            },
            goToBeitrag: "Zum Beitrag {%s}",
            openFolder: "Dateien des Ordners {%s} einblenden",
            closeFolder: "Dateien des Ordners {%s} ausblenden",
        },
    },
} as const;
